export const MANUAL_BLOCK = 'MANUAL_BLOCK';
export const MANUAL_SPAM = 'MANUAL_SPAM';
export const SYSTEM_RULES = 'SYSTEM_RULES';
export const NOT_FILTERED = 'NOT_FILTERED';
export const MANUAL = 'MANUAL';